import React from 'react';
import styled from 'styled-components/macro';
import {
  Heading2, Bold, Paragraph,
} from '../../components/typography';
import {
  Container,
  Row,
  Col,
  Div,
} from '../../components/grid';
import SidemenuLayout from '../../layout/DefaultLayout/Layouts/SidemenuLayout';
import { Grid } from './KulsyreTilFadoel';
import { Content } from './Kulsyre';
import { Item } from '../../containers/commerce';
import ProductViewKulsyre from '../../components/commerce/ProductViews/ProductViewKulsyre';

const ImgDiv = styled(Div)`
  background-size: cover;
  background-repeat: no-repeat;
  background-position: bottom center;
  min-height: 300px;
  width: 100%;
  height: 100%;
  border-radius: 15px;
`;

export default () => (
  <SidemenuLayout menuPicker="Kulsyre" activeSidemenu="KulsyreAkvarier">
    <Container white mb>
      <Row>
        <Col xs={12} lg={6} id="akvarie">
          <Heading2>Kulsyre til Akvarier</Heading2>
          <Paragraph>
            <Bold>Har du brug for kulsyre til dit akvarium?</Bold>
          </Paragraph>
          <Paragraph>
            Vi tilbyder kulsyreflasker til akvarier, så dine planter og fisk kan trives.
          </Paragraph>
          <Paragraph>
            Kulsyre er en gas, der er afgørende for at skabe et sundt og balanceret miljø i akvarier. Planter bruger kulsyren til at udføre fotosyntese, hvor de omdanner sollys til energi og producerer ilt som biprodukt. Denne proces er afgørende for at opretholde et højt iltindhold i vandet, som er vigtigt for fiskens åndedræt og andre vandlevende organismer.
          </Paragraph>
          <Paragraph>
            Derudover hjælper kulsyren med at opretholde pH-niveauet i akvariet, som er afgørende for sundheden og trivslen af dine akvariumsbeboere. pH-niveauet i vandet skal være i det rigtige område for at undgå sygdomme og stress, og kulsyren kan hjælpe med at regulere dette niveau.
          </Paragraph>
        </Col>
        <Col xs={12} lg={6} textCenter>
          <ImgDiv bgImage="kulsyre.akvarie.png" />
        </Col>
      </Row>
    </Container>
    <Container>
      <Row>
        <Col xs={12} padding="0">
          <Grid>
            <Content product>
              <Item varenr="8940" display={ProductViewKulsyre} />
            </Content>
            <Content product>
              <Item varenr="8944" display={ProductViewKulsyre} />
            </Content>
          </Grid>
        </Col>
      </Row>
    </Container>
  </SidemenuLayout>
);
